/* eslint-disable */
export default {
  forward: 'Inoltra',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
